import { FontFamily } from '@euler/components/typography';
import { roleStringToUserRoles } from '@euler/functions/orgUserUtils';
import { OrgUserRoleType } from '@euler/model/enum';
import { memo, useMemo } from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';

export const MemberTitle = memo(
  ({
    role,
    jobTitle,
    style,
  }: {
    role: string | null | undefined;
    jobTitle?: string;
    style?: StyleProp<TextStyle>;
  }) => {
    const title = useMemo(() => {
      if (jobTitle) {
        return jobTitle;
      }
      const roles = roleStringToUserRoles(role);
      if (
        roles.includes(OrgUserRoleType.ServiceAgents) &&
        roles.includes(OrgUserRoleType.Technicians)
      ) {
        return '服务顾问/维保技师';
      } else if (roles.includes(OrgUserRoleType.ServiceAgents)) {
        return '服务顾问';
      } else if (roles.includes(OrgUserRoleType.Technicians)) {
        return '维保技师';
      } else if (roles.includes(OrgUserRoleType.Manager)) {
        return '门店经理';
      } else if (roles.includes(OrgUserRoleType.Quoter)) {
        return '报价专员';
      } else if (roles.includes(OrgUserRoleType.Financial)) {
        return '财务专员';
      } else if (roles.includes(OrgUserRoleType.Marketer)) {
        return '营销专员';
      } else if (roles.includes(OrgUserRoleType.Administrator)) {
        return '门店管理';
      }
      return '门店员工';
    }, [jobTitle, role]);
    return (
      <Text
        css={`
          font-family: ${FontFamily.NotoSans.Regular};
        `}
        style={style}
      >
        {title}
      </Text>
    );
  },
);
